import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_NOTIFICA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeNotificaListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';
import { selectNotificaList } from '../../data.selector';

const retrieveNotificaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_NOTIFICA_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_NOTIFICA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ notificaLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ notifica: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({
              path: `notifica/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }

              // lazy load
              if (body?.append) {
                const currentList = selectNotificaList(state)?.result;
                return {
                  total: p?.total,
                  result: [...(currentList ?? []), ...p?.result],
                };
              }

              return {
                total: p?.total,
                result: [...p?.result, ...filler],
              };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_NOTIFICA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeNotificaListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_NOTIFICA_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ notificaLoader: false }))
      );
    })
  );

export default retrieveNotificaListEpic;
